module.exports = () => {
	return new Promise((resolve) => {
		return resolve(navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack || '');
	});
};
